import React from 'react'
import { Settings } from 'lucide-react'

interface SearchOptionsProps {
  caseSensitive: boolean
  matchType: 'exact' | 'partial' | 'regex'
  onCaseSensitiveChange: (value: boolean) => void
  onMatchTypeChange: (value: 'exact' | 'partial' | 'regex') => void
}

export const SearchOptions: React.FC<SearchOptionsProps> = ({
  caseSensitive,
  matchType,
  onCaseSensitiveChange,
  onMatchTypeChange
}) => {
  return (
    <div className="flex items-center space-x-4 p-3 bg-gray-50 rounded-lg">
      <div className="flex items-center space-x-2">
        <Settings className="h-4 w-4 text-gray-500" />
        <span className="text-sm font-medium text-gray-700">検索オプション:</span>
      </div>
      
      <div className="flex items-center space-x-2">
        <label className="flex items-center space-x-1">
          <input
            type="checkbox"
            checked={caseSensitive}
            onChange={(e) => onCaseSensitiveChange(e.target.checked)}
            className="rounded border-gray-300 text-primary-600 focus:ring-primary-500"
          />
          <span className="text-sm text-gray-700">大文字小文字を区別</span>
        </label>
      </div>
      
      <div className="flex items-center space-x-2">
        <span className="text-sm text-gray-700">一致方法:</span>
        <select
          value={matchType}
          onChange={(e) => onMatchTypeChange(e.target.value as 'exact' | 'partial' | 'regex')}
          className="text-sm border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        >
          <option value="partial">部分一致</option>
          <option value="exact">完全一致</option>
          <option value="regex">正規表現</option>
        </select>
      </div>
    </div>
  )
} 